export default "__VITE_ASSET__DZ9X7jUk__"